import React from 'react';

interface StatsCardProps {
  label: string;
  value: string | number;
  valueColor?: string;
  icon?: React.ReactNode;
  highlight?: boolean;
  highlightColor?: 'yellow' | 'red' | 'blue' | 'green';
}

const highlightClasses = {
  yellow: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800',
  red: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800',
  blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800',
  green: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800',
};

const highlightTextColors = {
  yellow: 'text-yellow-600 dark:text-yellow-400',
  red: 'text-red-600 dark:text-red-400',
  blue: 'text-blue-600 dark:text-blue-400',
  green: 'text-green-600 dark:text-green-400',
};

export function StatsCard({label, value, valueColor, icon, highlight = false, highlightColor = 'yellow'}: StatsCardProps) {
  const baseClasses = highlight
    ? `rounded-lg shadow p-4 border ${highlightClasses[highlightColor]}`
    : 'bg-white dark:bg-gray-800 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700';

  const defaultValueColor = highlight ? highlightTextColors[highlightColor] : 'text-gray-900 dark:text-gray-100';

  return (
    <div className={baseClasses}>
      {icon && <div className="mb-2">{icon}</div>}
      <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{label}</p>
      <p className={`text-2xl font-bold mt-1 ${valueColor || defaultValueColor}`}>{value}</p>
    </div>
  );
}
